import { useState } from 'react';
import { Button, DatePicker, Input, Select, Table } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import useFinanceTable from '../../../hooks/useFinanceTable';
import { orderExport, orderList } from '../../../api/finance';
import FinanceExportButton from '../../../components/finance/FinanceExportButton';
import FinanceStatusTag from '../../../components/finance/FinanceStatusTag';
import { can } from '../../../util/permission';
import { dayEnd, dayStart, formatDateTime, formatMoney } from '../../../util/finance';

export default function OrderTab() {
  const table = useFinanceTable(orderList);
  const [form, setForm] = useState({ orderNo: '', range: null, entryStatus: undefined, userId: '' });

  const search = () => {
    table.search({
      orderNo: form.orderNo || undefined,
      startTime: form.range ? dayStart(form.range[0]) : undefined,
      endTime: form.range ? dayEnd(form.range[1]) : undefined,
      entryStatus: form.entryStatus,
      userId: form.userId || undefined,
    });
  };

  const reset = () => {
    setForm({ orderNo: '', range: null, entryStatus: undefined, userId: '' });
    table.reset();
  };

  const columns = [
    { title: '订单号', dataIndex: 'orderNo', width: 100, fixed: 'left' },
    { title: '任务名称', dataIndex: 'title', width: 240, ellipsis: true },
    { title: '接单用户ID', dataIndex: 'userId', width: 110 },
    { title: '姓名', dataIndex: 'realName', width: 100 },
    { title: '税前赏金', dataIndex: 'grossReward', width: 120, render: formatMoney },
    { title: '平台服务费', dataIndex: 'platformFee', width: 120, render: formatMoney },
    { title: '实际结算金额', dataIndex: 'settlementAmount', width: 130, render: formatMoney },
    {
      title: '订单状态',
      dataIndex: 'taskStatusText',
      width: 110,
      render: (text) => <FinanceStatusTag text={text} />,
    },
    { title: '完成时间', dataIndex: 'completionTime', width: 170, render: formatDateTime },
    {
      title: '入账状态',
      dataIndex: 'entryStatusText',
      width: 100,
      render: (text) => <FinanceStatusTag text={text} />,
    },
  ];

  return (
    <div>
      <div className="finance-toolbar">
        <Input
          value={form.orderNo}
          onChange={(e) => setForm({ ...form, orderNo: e.target.value.replace(/\D/g, '') })}
          placeholder="订单号"
          style={{ width: 120 }}
          allowClear
        />
        <DatePicker.RangePicker
          showTime
          value={form.range}
          onChange={(value) => setForm({ ...form, range: value })}
          style={{ width: 360 }}
        />
        <Select
          value={form.entryStatus}
          onChange={(value) => setForm({ ...form, entryStatus: value })}
          placeholder="入账状态"
          allowClear
          style={{ width: 120 }}
          options={[
            { value: 1, label: '已入账' },
            { value: 0, label: '未入账' },
          ]}
        />
        <Input
          value={form.userId}
          onChange={(e) => setForm({ ...form, userId: e.target.value.replace(/\D/g, '') })}
          placeholder="接单用户ID"
          style={{ width: 120 }}
          allowClear
        />
        <Button type="primary" icon={<SearchOutlined />} onClick={search}>
          查询
        </Button>
        <Button onClick={reset}>重置</Button>
        {can('finance:order:export') && (
          <FinanceExportButton exportApi={orderExport} query={table.query} />
        )}
      </div>
      <Table
        className="finance-table"
        columns={columns}
        dataSource={table.data}
        rowKey="orderNo"
        loading={table.loading}
        scroll={{ x: 1500 }}
        rowClassName={(_, index) => (index % 2 === 1 ? 'finance-row-odd' : '')}
        pagination={{
          current: table.pagination.current,
          pageSize: table.pagination.pageSize,
          total: table.total,
          showSizeChanger: true,
          showTotal: (total) => `共 ${total} 条数据`,
          pageSizeOptions: ['10', '20', '50', '100'],
          onChange: table.onTableChange,
        }}
      />
    </div>
  );
}
